// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apis: {
    baseUrl: 'https://back.preprod.acp.com.tn/wp-json/acp/v1',
    document: 'https://back.preprod.acp.com.tn/',
    document_path: 'https://back.preprod.acp.com.tn/wp-content/uploads/',
    auth: 'https://back.preprod.acp.com.tn/',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
